var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M30 11V4a2 2 0 0 0-2-2h-7a1 1 0 1 0 0 2h5.586L15.293 15.293a1 1 0 0 0 1.414 1.414L28 5.414V11a1 1 0 1 0 2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4 9a3 3 0 0 1 3-3h8a1 1 0 1 0 0-2H7a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h16a5 5 0 0 0 5-5v-8a1 1 0 1 0-2 0v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
})));
export default SvgExternalLink;